import styled from "styled-components";

export const NotificationsStyled = styled.div`
  .notification__block {
    top: 100%;
    width: 900px;
  }
`
